export default "__VITE_ASSET__DXeD8jFc__"